exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label[data-v-707aa282]{font-size:.9em;font-weight:500;margin-bottom:0!important;margin-top:.25rem!important}.field-group-gray[data-v-707aa282]{background:#f9f9f9;border:1px solid #e4e4e4;margin-bottom:2rem!important;padding:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-707aa282","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./assets/js/ProgramCheckout.vue
// module id = 30
// module chunks = 0